import {
  pushProductCompare,
  popProductCompare,
  setCompareDate,
  clearCompare,
  openCompare,
  toggleShowDifferences,
} from '@/context/compare/action-creators';

export default dispatch => ({
  pushProductCompare: payload => dispatch(pushProductCompare(payload)),
  popProductCompare: payload => dispatch(popProductCompare(payload)),
  setCompareDate: payload => dispatch(setCompareDate(payload)),
  clearCompare: payload => dispatch(clearCompare(payload)),
  openCompare: payload => dispatch(openCompare(payload)),
  toggleShowDifferences: () => dispatch(toggleShowDifferences()),
});
